<template>
  <div class="foot">
    <div class="foot-connect">
      <div class="connect-we">
        <div class="caption">联系我们</div>
        <ul class="message">
          <li class="msg-li">地址：浙江省杭州市上城区丁兰街道临丁路1190号8楼808</li>
          <li class="msg-li">电话：0571-56606030</li>
          <li class="msg-li">E-Mail：helijun@jaxc.cn</li>
        </ul>
      </div>
      <div class="connect-we">
        <div class="caption">相关站点</div>
        <ul class="message">
          <li class="msg-li" style="width: 359px;"><a class="connect-a" href="http://tb.hangzhou.gov.cn/" target="_blank">杭州交通信息网</a>
              <!-- <a class="connect-a" href="http://www.hangzhou.gov.cn/art/2015/11/12/art_1256490_2698.html" target="_blank">杭州市机动车服务管理局</a> -->
            </li>
          <!-- <li class="msg-li"><a class="connect-a" href="http://zhejiang.weizhangwang.com/" target="_blank">浙江交通违章查询</a> </li> -->
        </ul>
      </div>
      <div class="connect-code">
        <div class="scan-code">
          <img
            class="code-img"
            src="../assets/zlxcimgs/home_icon_appxiazai@2x.png"
          >
          <p class="code-text">扫码关注公众号</p>
        </div>
        <div class="scan-code">
          <img
            class="code-img"
            src="../assets/zlxcimgs/category_icon01@2x.png"
          >
          <p class="code-text">扫码下载</p>
        </div>
      </div>
    </div>
    <div class="foot-area">
      <div class="copyright">
        <span class="first"><pre><br v-if="$store.getters.mobile"/>  版权所有：杭州市机动车驾驶人培训行业协会  指导单位：杭州市交通运输管理服务中心</pre></span><br/>
        <span class="a-first" target="_bank" href="javascript:void(0);">技术支持：杭州钧安科技有限公司</span><br v-if="$store.getters.mobile"/>  
        <span class="row">
          <img src="../assets/images/beian.png" alt="">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33010602013393" target="_bank">浙公网安备33010602013393号</a>
        </span>
        <a target="_bank" href="https://beian.miit.gov.cn"> 浙ICP备2023051155号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Foot',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./foot.scss";
.row {
  display: inline-block;
  text-align: center;
  margin-right: 6px;
  img {
    width: 16px;
    height: 18px;
    margin: -2px 4px 0 6px;
    vertical-align:middle
  }
}
</style>
